__webpack_require__.p = "https://payment-processing-pmnts-qa.getsquire.com/";